import { type ReactElement } from 'react';

import { alpha, Button, type ButtonProps, styled } from '@mui/material';

type OmittedProps = 'variant';

export type SecondaryButtonProps = Omit<ButtonProps, OmittedProps>;

const SecondaryButtonBootsrap = styled(Button)<SecondaryButtonProps>(({
  theme,
}) => {
  const disabledColorWithOpacity = alpha(theme.palette.gray300.main, 0.2);

  return {
    '&.MuiButton-outlined': {
      color: theme.palette.blue.main,
      backgroundColor: theme.palette.white.main,
      borderWidth: 1,
      borderRadius: 8,
      textTransform: 'none',
      borderColor: theme.palette.blue.main,
      '&:hover': {
        backgroundColor: theme.palette.blue.main + '20',
      },
      '&.Mui-disabled': {
        color: disabledColorWithOpacity,
        borderColor: disabledColorWithOpacity,
      },
      '&:focus': {
        outline: 0,
      },
    },
  };
});

export const SecondaryButton = (props: SecondaryButtonProps): ReactElement => (
  <SecondaryButtonBootsrap {...props} variant="outlined" />
);
